export default {"link-dwn":"activated-units-history-module__link-dwn___msSn4","link":"activated-units-history-module__link___Nq12b"}
import '/home/jenkins/agent/workspace/eUI.Release_release_wfdasui_0.22/lib/modules/main/app/components/activatedUnitsHistory/activated-units-history.module.css'
